<template>
  <div class="container">
    <ul class="beneficios">
      <li class="items-beneficios"><img src="../assets/img/reciclable.jpg"></li>
      <li class="items-beneficios"> 
        <div class="lista-kraft">
          <h2 class="titulo-secundario">Kraft</h2>
          <ul>
            <li>Mayor resistencia que el papel común</li>
            <li>Textura rugosa, muy artesanal</li>
            <li>Es un material amigable con el medio ambiente</li>
            <li>100% ecológico</li>
            <li>100% reciclable</li>
            <li>Soporta altas temperaturas</li>
            <li>Se descompone rapidamentes</li>
            <li>Es económico</li>
          </ul>
        </div>
       </li>
      <li class="items-beneficios"><img src="../assets/img/biodegradable.jpg"></li>
    </ul>
 
  </div>
</template>

<script>

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { mapState } from 'vuex'

  export default {
    data() {
      return {
       
      }
    },
    methods: {
    handleResize() {
     
     }
    },
    beforeCreate(){
        
    },
    computed: {
      ...mapState(['featuredProducts'])
    }
  }
</script>

<style lang="scss" scoped>
  .swiper-container {
    background-color: transparent;
  }
 
</style>